// src/services/moduleService.ts

import axios from "axios";
import { API_ENDPOINTS } from '../../../apiConfig';
const API_BASE =  `${API_ENDPOINTS.platform}/modules`;
//const BASE_URL = "/api/modules";

export const fetchModules = () => axios.get(`${API_BASE}`);
export const getModule = (id: string) => axios.get(`${API_BASE}/${id}`);
export const createModule = (data: any) => axios.post(`${API_BASE}`, data);
export const updateModule = (id: string, data: any) => axios.put(`${API_BASE}/${id}`, data);
export const deleteModule = (id: string) => axios.delete(`${API_BASE}/${id}`);